/*
 * @Author: caiqin.xie
 * @since: 2023-08-14 19:23:26
 * @lastTime: 2023-11-10 11:26:32
 * @LastEditors: caiqin.xie
 * @message: 产品支持-快速开始
 */
import React from "react";
import { productSatrtList } from '@/common/const'
import styles from "../../index.module.scss";
import LazyMedia from "@/components/LazyMedia"

interface IProps {
  ctry: string;
  words: Record<string, string>;
  productId: string; // 产品id
}

const QuickStart = (props:IProps) => {
  const {ctry, words, productId} = props
  return (
    <section className={styles['product-section']}>
      <h2 className={styles['product-section-title']}>{words?.support_product_quick_start_title}</h2>
      {/* Quick start */}
      <div className={styles['quick-start-list']}>
        {productSatrtList.map(item => (
          <div key={item.id} className={styles['quick-start-item']}>
            <LazyMedia type="image" src={item.icon} alt="" className={styles['item-img']} />
            <p className={styles['item-title']}>{words[item.title]}</p>
            <p className={styles['item-desc']}>{words[item.desc]}</p>
            {item.id === '1' && productId && (
              <a href={`/${ctry}${item.path}/${productId}`}>
                <span className={styles['learn-more']}>{words?.common_learn_more}</span>
              </a>
            )}
            {item.id === '3' && (
              <a href={item.path} target="_blank" className={styles['learn-more']}>{words?.common_learn_more}</a>
            )}
            {['2', '4'].includes(item.id) && (
              <a href={`/${ctry}${item.path}`}>
                <span className={styles['learn-more']}>{words?.common_learn_more}</span>
              </a>
            )}
            {/* Learn more */}
          </div>
        ))}
      </div>
    </section>
  )
}
export default QuickStart